import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0132',
    ecrans: ['00-2']
});
